export enum CraftItemType {
  requirement = 1,
  story = 2,
  improvement = 3,
  task = 4,
  bug = 5,
  pageStory = 6,
  topic = 7,
  feature = 8,
  subtask = 9,
}
